import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, unref as _unref, normalizeClass as _normalizeClass, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { Disclosure, DisclosureButton, DisclosurePanel } from '@headlessui/vue'
import { ChevronDownIcon } from '@heroicons/vue/20/solid'


export default /*#__PURE__*/_defineComponent({
  __name: 'AccordionComponent',
  props: {
    centerTitle: {
        type: Boolean,
        default: false
    },
    disabled: {
        type: Boolean,
        default: false
    },
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(Disclosure), {
    as: "div",
    class: _normalizeClass(["rounded-2xl", __props.disabled ? 'pointer-events-none bg-gray-30' : 'bg-white'])
  }, {
    default: _withCtx(({ open }) => [
      _createVNode(_unref(DisclosureButton), { class: "w-full" }, {
        default: _withCtx(() => [
          _createElementVNode("div", {
            class: _normalizeClass([[__props.centerTitle ? 'justify-center' : 'justify-between', __props.disabled ? 'text-darkgray-400' : ''], "flex w-full items-center px-5 py-4"])
          }, [
            _renderSlot(_ctx.$slots, "title"),
            _createVNode(_unref(ChevronDownIcon), {
              class: _normalizeClass([[open ? '' : '', __props.disabled ? 'text-darkgray-400' : 'text-primary-500'], "h-5 w-5 ml-4"])
            }, null, 8, ["class"])
          ], 2)
        ]),
        _: 2
      }, 1024),
      _createVNode(_unref(DisclosurePanel), {
        as: "template",
        class: "px-5 pt-0 pb-6"
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", null, [
            _renderSlot(_ctx.$slots, "content")
          ])
        ]),
        _: 3
      })
    ]),
    _: 3
  }, 8, ["class"]))
}
}

})